/**
 * Phiên bản build cho từng loại asset tĩnh.
 * Tăng số version sau mỗi lần deploy file tương ứng lên CDN để tránh cache cũ.
 */
export const VERSION_BUILD = {
  translate: 2,
};

